<script>
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <div class="col-12 d-flex card">
    <div class="col-md-6 row mx-auto card-body">
      <div
        class="spinner-grow text-primary"
        style="width: 3rem; height: 3rem"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <div class="col-md-6">
        <h4 class="mt-3 text-primary">Loading...</h4>
      </div>
    </div>
  </div>
</template>
